module.exports = __webpack_public_path__ + "static/media/mobile-background-3x.15f11ffb.jpg";